import React, { Component } from 'react';
import '../../styles/dashboard.css';
import { Switch, Route, Redirect } from 'react-router-dom';
import Inspections from '../app/dashboard/inspections/inspections';
import Inspection from '../app/dashboard/inspection';
import InspectionDetailAction from './../../redux/actions/inspection';

import { 
	ROUTE_DASHBOARD,
	ROUTE_DASHBOARD_INSPECTIONS
} from '../../constants/routes/routes-ui';
import HeaderApp from '../app/dashboard/chunks/header';
import UiAction from '../../redux/actions/ui';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SidebarApp from '../app/dashboard/chunks/sidebar'
import AuthAction from '../../redux/actions/auth';
import { STATUS_SERVICE } from '../../constants/app/services';
import AuthToken from '../../lib/common/auth-token';

class Dashboard extends Component {
	componentDidMount(){
			if(AuthToken.getToken()){
				this.props.me();
			}
	}
	render() {
		const { toggleDrawer, openMenu, user ={} } = this.props;
		const dashboard = (
			<div className="Dashboard">
				<HeaderApp toggleDrawer={toggleDrawer} user={user}/>
				<SidebarApp toggleDrawer={toggleDrawer} open={openMenu} user={user} logout={this.props.logout} getReportInspection={this.props.getReportInspection} statusReport={this.props.statusReport} getReportInspectionReset={this.props.getReportInspectionReset} url={this.props.url} isViewer={this.props.isViewer}/>
				<div className="Dashboard-container">
					<Switch>
						{/*  list inspections */}
						<Route exact path={ROUTE_DASHBOARD}>
							<Inspections isViewer={this.props.isViewer}/>
						</Route>
						{/* detail inspection */}
        				<Route exact path={ROUTE_DASHBOARD_INSPECTIONS} component={Inspection} />
					</Switch>
					
				</div>
			</div>
		);

		switch(true){	
			case ((this.props.statusMe === STATUS_SERVICE.ERROR) || (this.props.logoutOk && (this.props.statusLogin === STATUS_SERVICE.INITIAL))): {
				this.props.logout();
				return <Redirect to='/' />
			}
			case ((this.props.statusMe === STATUS_SERVICE.SUCCESS) && (this.props.statusMe === STATUS_SERVICE.SUCCESS)):
				return dashboard;
			default:
				return <div>Loading..</div>
		}
	}
}

const mapStateToProps = (state, ownProps) => ({
	openMenu: state.UIReducer.openMenu,
	statusMe: state.AuthReducer.statusMe,
	statusLogin: state.AuthReducer.statusLogin,
	user: state.AuthReducer.user,
	logoutOk: state.AuthReducer.logoutOk,
	statusReport: state.AuthReducer.statusReport,
	url: state.AuthReducer.url,
	isViewer: state.AuthReducer.isViewer
})
const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
	toggleDrawer: UiAction.toggleDrawer,
	me: AuthAction.me,
	logout: AuthAction.logoutOk,
	getReportInspection: AuthAction.getReportInspection,
	getReportInspectionReset: AuthAction.getReportInspectionReset,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard) ;


// WEBPACK FOOTER //
// ./src/components/layouts/dashboard.js